<template>
    <app-layout :title="'Survey analytics for ' + surveyModel.name">

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
export default {
    name: "Analytics",
    components: {AppLayout},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
